import React from 'react';
import PropTypes from 'prop-types';
import { Button, Form, Row, Col } from 'react-bootstrap';

export default function AdminPagination({
  page,
  total,
  limit,
  onPageChange,
  disabled,
}) {
  const totalPages = Math.max(1, Math.ceil(total / limit) || 1);

  return (
    <div className="d-flex justify-content-between align-items-center mt-2 flex-wrap">
      <small className="text-muted">
        Página {page} de {totalPages} ({total} registros)
      </small>
      <div>
        <Button
          size="sm"
          variant="outline-secondary"
          disabled={disabled || page <= 1}
          onClick={() => onPageChange(page - 1)}
          className="mr-1"
        >
          Anterior
        </Button>
        <Button
          size="sm"
          variant="outline-secondary"
          disabled={disabled || page >= totalPages}
          onClick={() => onPageChange(page + 1)}
        >
          Próxima
        </Button>
      </div>
    </div>
  );
}

AdminPagination.propTypes = {
  page: PropTypes.number.isRequired,
  total: PropTypes.number.isRequired,
  limit: PropTypes.number.isRequired,
  onPageChange: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
};

AdminPagination.defaultProps = {
  disabled: false,
};

export function AdminSearchRow({ q, onChange, placeholder, children }) {
  return (
    <Row className="mb-3">
      <Col xs={12} md={6}>
        <Form.Control
          type="search"
          placeholder={placeholder}
          value={q}
          onChange={e => onChange(e.target.value)}
          aria-label={placeholder}
        />
      </Col>
      {children && <Col xs={12} md={6}>{children}</Col>}
    </Row>
  );
}

AdminSearchRow.propTypes = {
  q: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  placeholder: PropTypes.string,
  children: PropTypes.node,
};

AdminSearchRow.defaultProps = {
  placeholder: 'Buscar...',
  children: null,
};
